import Clap from "../assets/emoji_clap.png";
import Like from "../assets/emoji_thumbs.png";
import Confused from "../assets/emoji_monocle.png";
// TODO: This needs to be solved in a future issue.
import "./EmojiReaction.scss";

export const emojiTypes = {
  clap: Clap,
  like: Like,
  confused: Confused,
};
